/** Research-use strings, verbatim from the desktop app's Assets/Scripts/Compliance/ResearchUse.cs.
 * The only place they are written in TypeScript (the backend has shared/research_use.py with the
 * same headline). Never retype them elsewhere. */

export const APP_VERSION: string = __APP_VERSION__;

export const RESEARCH_USE = {
  code: 'research_use_only',
  headline: 'For Research Use Only. Not for use in diagnostic procedures.',
  short: 'RESEARCH USE ONLY - NOT FOR DIAGNOSTIC USE',
  statementDetail:
    'Valvia is research software. It has not been cleared or approved by the U.S. Food and Drug ' +
    'Administration, and its performance characteristics have not been established. Do not use ' +
    'Valvia or anything it produces (images, measurements, 3-D models, reports) to diagnose, plan ' +
    'or guide the treatment of any patient.',
  manufacturer: 'Microscape Inc.',
  licenseLine: 'Use of Valvia is governed by the Valvia Research Use License.',
  conditions: [
    'I will use Valvia only for research approved by my institution (IRB approval or exemption, or the equivalent).',
    'Nothing Valvia produces will be used to diagnose, plan or guide the care of any patient.',
    'I will use patient data in Valvia only as my institution permits (for example, de-identified data, or data covered by an IRB waiver or authorization).',
  ],
  acknowledgeLabel: 'I understand and agree.',
  modalTitle: 'Research use only',
  conditionsTitle: 'Conditions of use',
  continueLabel: 'Continue',
  aboutTitle: 'About Valvia',
  /** Window title suffix (desktop: "VALVIA — For Research Use Only"). */
  titleSuffix: ' — For Research Use Only',
  versionFooter: (version: string) => `Version ${version} · Research use only`,
} as const;

export const RESEARCH_USE_STATEMENT = `${RESEARCH_USE.headline} ${RESEARCH_USE.statementDetail}`;

declare global {
  const __APP_VERSION__: string;
}
